var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFullscreenSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7289_1535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3885 17.5C3.1446 17.5 2.93554 17.4129 2.76132 17.2387C2.58711 17.0645 2.5 16.8554 2.5 16.6115V13.0575C2.5 12.8136 2.58711 12.6045 2.76132 12.4303C2.93554 12.2561 3.15331 12.169 3.41463 12.169C3.65854 12.169 3.86324 12.2561 4.02875 12.4303C4.19425 12.6045 4.277 12.8136 4.277 13.0575V15.723H6.94251C7.18641 15.723 7.39547 15.8057 7.56969 15.9713C7.7439 16.1368 7.83101 16.3502 7.83101 16.6115C7.83101 16.8554 7.7439 17.0645 7.56969 17.2387C7.39547 17.4129 7.18641 17.5 6.94251 17.5H3.3885ZM3.3885 7.83101C3.1446 7.83101 2.93554 7.7439 2.76132 7.56969C2.58711 7.39547 2.5 7.18641 2.5 6.94251V3.3885C2.5 3.1446 2.58711 2.93554 2.76132 2.76132C2.93554 2.58711 3.1446 2.5 3.3885 2.5H6.94251C7.18641 2.5 7.39547 2.58711 7.56969 2.76132C7.7439 2.93554 7.83101 3.15331 7.83101 3.41463C7.83101 3.65854 7.7439 3.86324 7.56969 4.02875C7.39547 4.19425 7.18641 4.277 6.94251 4.277H4.277V6.94251C4.277 7.18641 4.19425 7.39547 4.02875 7.56969C3.86324 7.7439 3.64983 7.83101 3.3885 7.83101ZM13.0575 17.5C12.8136 17.5 12.6045 17.4129 12.4303 17.2387C12.2561 17.0645 12.169 16.8467 12.169 16.5854C12.169 16.3415 12.2561 16.1368 12.4303 15.9713C12.6045 15.8057 12.8136 15.723 13.0575 15.723H15.723V13.0575C15.723 12.8136 15.8057 12.6045 15.9713 12.4303C16.1368 12.2561 16.3502 12.169 16.6115 12.169C16.8554 12.169 17.0645 12.2561 17.2387 12.4303C17.4129 12.6045 17.5 12.8136 17.5 13.0575V16.6115C17.5 16.8554 17.4129 17.0645 17.2387 17.2387C17.0645 17.4129 16.8554 17.5 16.6115 17.5H13.0575ZM16.5854 7.83101C16.3415 7.83101 16.1368 7.7439 15.9713 7.56969C15.8057 7.39547 15.723 7.18641 15.723 6.94251V4.277H13.0575C12.8136 4.277 12.6045 4.19425 12.4303 4.02875C12.2561 3.86324 12.169 3.64983 12.169 3.3885C12.169 3.1446 12.2561 2.93554 12.4303 2.76132C12.6045 2.58711 12.8136 2.5 13.0575 2.5H16.6115C16.8554 2.5 17.0645 2.58711 17.2387 2.76132C17.4129 2.93554 17.5 3.1446 17.5 3.3885V6.94251C17.5 7.18641 17.4129 7.39547 17.2387 7.56969C17.0645 7.7439 16.8467 7.83101 16.5854 7.83101Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7289_1535",
    x: 1.5,
    y: 2.5,
    width: 17,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7289_1535"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7289_1535",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreenSquare);
export default __webpack_public_path__ + "static/media/icon-fullscreen-square.301ff1b94e38ba9e026a29d8d85ba117.svg";
export { ForwardRef as ReactComponent };